import Vue from 'vue'
import Router from 'vue-router'
import HomeContainer from '../page/home/home.vue'
import HomeMajor from '../page/home/homeMajor.vue'
import detailContainer from '../page/detail/detail.vue'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'home',
    component: HomeContainer,
    meta: {
      keepAlive: true
    }
  }, {
    path: '/homeMajor',
    name: 'homeMajor',
    component: HomeMajor,
    meta: {
      keepAlive: true
    }
  }, {
    path: '/detail',
    name: 'detail',
    component: detailContainer,
    meta: {
      keepAlive: false
    }
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js